import Header from "./Header";
import { Confirm } from "../../components/shared";
import { useDispatch } from "react-redux";
import useAppLogout from "../../hooks/useAppLogout";

const HeaderContainer = ({
    isSmallScreen,
    onToggle,
    setLogout = () => {},
    mobileCollapse, // True(show nav) / False(hide nav)-
}) => {
    const dispatch = useDispatch();
    const logout = useAppLogout();

    const onLogoutClick = () => {
        Confirm({
            title: "Logout Confirmation",
            icon: "",
            content: <p>Are you sure you want to Logout?</p>,
            onOk() {
                setLogout(); // Reset the Side Nav Menu to true/closed-
                return logout(dispatch);
            },
            onCancel() {},
            okText: "Yes",
            cancelText: "No",
            className: "isCancel",
        });
    };

    return (
        <Header
            mobile={isSmallScreen}
            onLogoutClick={onLogoutClick}
            onToggle={onToggle}
            mobileCollapse={mobileCollapse} // True(show nav) / False(hide nav)-
        />
    );
};

export default HeaderContainer;
